import "./App.css";
import Home from "./pages/Home/Home";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import Nav from "./components/Nav/Nav";
import Home_1 from "./pages/Home_1/Home_1";

function App() {
  return (
    <>
      <Nav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/delhi-ncr" element={<Home_1 />} />
      </Routes>
    </>
  );
}

export default App;
